module.exports = __webpack_public_path__ + "img/pDesign-banner.f39e3127.jpg";